import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import XHR from "i18next-xhr-backend"
import { initReactI18next } from "react-i18next"
// import languageEN from '../public/locales/en/translation.json'
// import languageAR from '../public/locales/ar/translation.json'

const defaultLanguage = localStorage.getItem("i18nextLng") || "en"

i18n.use(XHR)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // resources: {
        //   en: languageEN,
        //   ar: languageAR
        // },
        lng: defaultLanguage,
        fallbackLng: "en",
        debug: false,
        keySeparator: ".",
        react: {
            useSuspense: false
        }
    })

export default i18n
